import { addingEmailAutomationFlag } from '../../redux/slices/automation';
import { Close } from '@mui/icons-material';
import CustomDropdown from '../../components/reusable/dropdown';
import CustomInput from '../../components/reusable/input';
import { fieldsOptions } from '../../helper';
import LabelWrapper from '../../components/wrapper/label';
import { updateBuildAutomationThunk } from '../../redux/thunks/automation';
import { useRef } from 'react';
import { addNode, editSelectedNode, settingSelectedEdge, settingSelectedNode } from '../../redux/slices/workflow';
import { AppDispatch, RootState } from '../../redux/store';
import { Box, Button, IconButton, Typography } from '@mui/material';
import { emailAutomationSchema, emailSubjectAutomationSchema } from '../../schema/automation_schema';
import { Form, Formik } from 'formik';
import { useDispatch, useSelector } from 'react-redux';

interface EmailObject {
    type: 'phone' | 'condition' | 'email' | 'timer',
    action_name: string;
    subject: string;
    message: string;
}
interface QuillEditorRef {
    insertTextAtCursor: (text: string) => void;
}


const SetEmailComponent = () => {
    const dispatch = useDispatch<AppDispatch>();
    const quillEditorRef = useRef<QuillEditorRef>(null);
    const { selectedNode } = useSelector((state: RootState) => state.workflow);
    const { selectedAutomation, loaders } = useSelector((state: RootState) => state.automation);
    const initialValues: EmailObject = {
        type: 'email',
        action_name: (selectedNode?.data?.action_name as string) || '',
        subject: selectedAutomation?.email_thread === 1 ? selectedAutomation.email_subject || '' : (selectedNode?.data?.subject as string) || '',
        message: (selectedNode?.data?.message as string) || ''
    };

    const handleBackNavigation = () => {
        dispatch(settingSelectedNode(null));
        dispatch(settingSelectedEdge(null));
        dispatch(addingEmailAutomationFlag(false));
    };

    const handleSubmit = async (value: EmailObject) => {
        if (selectedNode) {
            dispatch(editSelectedNode(value));
        } else {
            dispatch(addNode(value));
        }
        try {
            await dispatch(updateBuildAutomationThunk()).unwrap();
        } catch (e) {
            // Catch errors
        }
        handleBackNavigation();
    };

    return (
        <Box width="100%">
            <Box display="flex" justifyContent="space-between" alignItems="center">
                <Box></Box>
                <Typography variant="h3" fontWeight="bold" textAlign="center">{selectedNode ? 'Update' : 'Set'} Email</Typography>
                <IconButton disabled={loaders.isUpdating} onClick={handleBackNavigation}><Close /></IconButton>
            </Box>
            <Box>
                <Formik
                    initialValues={initialValues}
                    validationSchema={selectedAutomation?.email_thread === 0 ? emailSubjectAutomationSchema : emailAutomationSchema}
                    onSubmit={handleSubmit}
                >
                    {({ values, handleChange, handleBlur, errors, touched, setFieldValue }) => {
                        return (<Form>
                            <Box display="flex" flexDirection="column" gap={2}>
                                {/* Input for stage name */}
                                <CustomInput
                                    value={values.action_name}
                                    onChange={handleChange('action_name')}
                                    onBlur={handleBlur('action_name')}
                                    error={touched.action_name && errors.action_name}
                                    fullWidth
                                    label="Action name:"
                                    placeholder="Type here"
                                    variant="outlined"
                                    disabled={loaders.isUpdating}
                                    mandatoryFields={true}
                                />
                                {/* Input for days due */}
                                {(selectedAutomation?.email_thread === 0) && <Box display="flex" flexDirection="column" gap={2}>
                                    <Box display="flex" justifyContent="space-between" alignItems="end">
                                        <LabelWrapper label="Subject:" sx={{ marginBottom: 0 }} />
                                        <Box>
                                            <CustomDropdown
                                                options={fieldsOptions}
                                                value=""
                                                placeholder="Add Field"
                                                onChange={(e) => {
                                                    setFieldValue('subject', `${values.subject} [${e.target.value}]`);
                                                }}
                                                disabled={loaders.isUpdating}
                                                sx={{ marginBottom: '0' }}
                                            />
                                        </Box>
                                    </Box>
                                    <CustomInput
                                        value={values.subject}
                                        onChange={handleChange('subject')}
                                        onBlur={handleBlur('subject')}
                                        error={touched.subject && errors.subject}
                                        fullWidth
                                        placeholder="Type here"
                                        variant="outlined"
                                        disabled={loaders.isUpdating}
                                        mandatoryFields={true}
                                    />
                                </Box>}
                                <Box display="flex" flexDirection="column" gap={2}>
                                    <Box display="flex" justifyContent="space-between" alignItems="end">
                                        <LabelWrapper label="Message:" sx={{ marginBottom: 0 }} />
                                        <Box>
                                            <CustomDropdown
                                                options={fieldsOptions}
                                                value=""
                                                placeholder="Add Field"
                                                onChange={(e) => {
                                                    // setFieldValue('message', `${values.message} [${e.target.value}]`);
                                                    const textToInsert = ` [${e.target.value}] `;
                                                    quillEditorRef.current?.insertTextAtCursor?.(textToInsert);
                                                }}
                                                disabled={loaders.isUpdating}
                                                sx={{ marginBottom: '0' }}
                                            />
                                        </Box>
                                    </Box>
                                    <Box>
                                        <CustomInput
                                            type="quill"
                                            value={values.message}
                                            name="message"
                                            quillEditorRef={quillEditorRef}
                                            placeholder="Type content here..."
                                            quillHeight="22vh"
                                            disabled={loaders.isUpdating}
                                            error={Boolean(errors.message && touched.message)}
                                            onChangeForPhone={(value: string) => setFieldValue('message', value)}
                                        />
                                        {/* <CustomToolbar />
                                        <ReactQuill
                                            onChange={(content) => setFieldValue('message', content)}
                                            value={values.message}
                                            placeholder="Type content here..."
                                            modules={quillModule}
                                            formats={quillFormats}
                                            theme="snow"
                                            readOnly={loaders.isUpdating}
                                            style={{
                                                height: '22vh',
                                                borderBottomLeftRadius: '10px',
                                                borderBottomRightRadius: '10px',
                                                border:  ? `1px solid ${red[300]}` : 'none'
                                            }}
                                        /> */}
                                    </Box>
                                </Box>
                                {/* Action buttons for cancel and submit */}
                                <Box display="flex" flexDirection="row-reverse" gap={2} mt={2}>
                                    <Button type="submit" variant="contained" color="primary" disabled={loaders.isUpdating}>
                                        {selectedNode && loaders.isUpdating ? 'Updating' : selectedNode ? 'Update' : loaders.isUpdating ? 'Creating' : 'Create'} action
                                    </Button>
                                    <Button variant="outlined" color="secondary" onClick={handleBackNavigation} disabled={loaders.isUpdating}>
                                        Cancel
                                    </Button>
                                </Box>
                            </Box>
                        </Form>);
                    }}
                </Formik>
            </Box>
        </Box>
    );
};

export default SetEmailComponent;